module.exports = __webpack_public_path__ + "static/media/photo194.ff50828b.jpg";